<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 31.262 32.689">
        <g id="name" transform="translate(-46 -174)">
            <circle id="Ellipse_46" data-name="Ellipse 46" cx="13.5" cy="13.5" r="13.5" transform="translate(46 174)"
                    fill="#c0d0fc" opacity="0.7"/>
            <g id="computer" transform="translate(54.517 178.257)">
                <path id="Path_69808" data-name="Path 69808"
                      d="M15.981,16.836a7.392,7.392,0,0,0,3.755-5.876,8.327,8.327,0,0,0,0-1.137A7.388,7.388,0,1,0,8.764,16.836,9.681,9.681,0,0,0,1,26.313a.569.569,0,0,0,.162.4,15.672,15.672,0,0,0,22.421,0,.569.569,0,0,0,.162-.4,9.681,9.681,0,0,0-7.764-9.477Zm-3.608-12.7A6.261,6.261,0,0,1,18.6,9.823H6.145A6.261,6.261,0,0,1,12.372,4.137ZM6.147,10.96H18.6a6.251,6.251,0,0,1-12.453,0Zm8.383,6.846-.346,1.683H10.561l-.346-1.683C10.837,17.774,13.928,17.775,14.53,17.807ZM12.372,30.294A14.439,14.439,0,0,1,2.141,26.082a8.541,8.541,0,0,1,6.94-8.146l.461,2.236a.569.569,0,0,0,.557.454h4.549a.569.569,0,0,0,.557-.455l.461-2.236A8.541,8.541,0,0,1,22.6,26.081a14.439,14.439,0,0,1-10.229,4.212Z"
                      transform="translate(-1 -2.999)" fill="#799cfb"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IName",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
